import { gql } from '@apollo/client';

import { GetPools } from './__generated__/getPools';

// Shared by every consumer of this query's `user.company.pools` selection -- centralized here,
// next to the query that produces it, instead of each consumer re-deriving an identical alias.
// Not to be confused with the differently-sourced `Pool` type some GetPoolsList consumers define
// locally -- same name, different query, genuinely different type.
export type Pool = NonNullable<
  NonNullable<NonNullable<NonNullable<GetPools>['user']>['company']>['pools']
>[number];

const GET_POOLS = gql`
  query GetPools {
    user {
      id
      company {
        id
        pools {
          id
          last_updated_date
          name
          asset_class
          created_date
          loan_count
          state
          t_current_balance_cents
          wa_coupon_bps
          wa_loan_age_months
          wa_borrower_credit_score
          wa_remaining_loan_terms_months
          wa_ltv_bps
          wa_dti_bps
          has_cra
          market_status
        }
      }
    }
  }
`;

export { GET_POOLS };
